import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { MplButton } from '@mopla/ui';

import { usePaymentStepStore } from '../../stores/usePaymentStepStore';
import { useRedirectToTrueLayer } from '../../utils';

export const SepaRedirectInfoStep = () => {
	const { t } = useTranslation('payment');
	const setPaymentStep = usePaymentStepStore((s) => s.setStep);

	const onRedirectToTrueLayerHandler = useRedirectToTrueLayer();

	const handleClick = useCallback(() => {
		onRedirectToTrueLayerHandler();
		// useRedirectToTrueLayer sets step to 'sepaAuthentication' internally,
		// which would briefly flash the old selection modal before redirect.
		// Override it back to 'sepaRedirect' to keep this modal visible.
		setPaymentStep('sepaRedirect');
	}, [onRedirectToTrueLayerHandler, setPaymentStep]);

	return (
		<Box sx={{ display: 'grid', gridGap: '16px' }}>
			<Typography variant="h3-sb" color="primary.main">
				{t('account_verification.title')}
			</Typography>
			<Typography variant="b1" color="primary.main">
				{t('account_verification.text')}
			</Typography>
			<MplButton onClick={handleClick}>
				{t('account_verification.button')}
			</MplButton>
		</Box>
	);
};
